import {all, call, put, takeLatest, takeLeading} from 'redux-saga/effects';
import {actions, ActionType} from './action';
import {getRankingTabContents, getSpecialContent} from './apiGet';
import callApi from '../../../common/util/api';
import {makeFetchSaga} from '../../../common/util/fetch';
import {
  fetchMainList,
  fetchRecommendList,
  fetchSpecialList,
  fetchWaitfreeList,
} from '../../common/state/callApi';

function* fetchSpecialContent(
  action: ReturnType<typeof actions.fetchSpecialContent>
) {
  const {id} = action.payload;
  const {success, data} = yield call(callApi, {
    url: `/bridge-page/v1/bridge-pages/${id}`,
  });

  if (success && data) {
    yield put(actions.setValue('specialContent', getSpecialContent(data)));
  }
}

function* fetchRankingTabContents(
  action: ReturnType<typeof actions.fetchRankingTabContents>
) {
  const {tag, isRealTimeRankingTab} = action.payload;
  const {success, data} = yield call(
    callApi,
    isRealTimeRankingTab
      ? {
          url: '/section/v4/sections',
          params: {
            placement: 'rank_all',
          },
        }
      : {
          url: '/section/v1/view/bundles',
          params: {tag},
        }
  );

  if (success && data) {
    // 실시간랭킹 탭은 tag정보로 호출이 불가능하여 placement:rank_all로 호출한다.
    // 이 때 rank_all의 데이터는 sections에 담겨있지 않기 때문에 아래와 같이 sections로 한번 감싸준다.

    yield put(
      actions.setRankingTabContents(
        getRankingTabContents(isRealTimeRankingTab ? {sections: data} : data)
      )
    );
  }
}

export default function* saga() {
  yield all([
    takeLeading(
      ActionType.FetchRecommendList,
      makeFetchSaga({fetchSaga: fetchRecommendList, canCache: false})
    ),
    takeLeading(
      ActionType.FetchSpecialList,
      makeFetchSaga({fetchSaga: fetchSpecialList, canCache: false})
    ),
    takeLeading(
      ActionType.FetchSpecialContent,
      makeFetchSaga({fetchSaga: fetchSpecialContent, canCache: false})
    ),
    takeLeading(
      ActionType.FetchWaitfreeList,
      makeFetchSaga({fetchSaga: fetchWaitfreeList, canCache: false})
    ),
    takeLeading(
      ActionType.FetchMainList,
      makeFetchSaga({fetchSaga: fetchMainList, canCache: false})
    ),
    takeLatest(
      ActionType.FetchRankingTabContents,
      makeFetchSaga({fetchSaga: fetchRankingTabContents, canCache: true})
    ),
  ]);
}
